import { create } from 'zustand';

interface NotificationBuilderState {
  notificationBuilderActive: boolean;
  setNotificationBuilderActive: (active: boolean) => void;
  activeEditNotificationId: string | null;
  setActiveEditNotificationId: (id: string | null) => void | null;
}

export const useNotificationBuilderStore = create<NotificationBuilderState>((set) => ({
  notificationBuilderActive: false,
  setNotificationBuilderActive: (active) => set({ notificationBuilderActive: active }),
  activeEditNotificationId: null,
  setActiveEditNotificationId: (id) => set({ activeEditNotificationId: id }),
}));
